<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">

    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="text-dark">{{ translationService.getTranslation('Reports') }}</h3>
    </div>

    <div class="d-flex flex-column mb-4">
      <div class="row">
        <div class="col-6 text-center">
        <div class="row g-4">
        <div class="col-6" *ngFor="let widget of widgets" (click)="selectWidget(widget)" data-bs-toggle="modal" data-bs-target="#widgetModal">
          <div class="card shadow-sm border-0 btn bg-light" style="height: 195px;">
            <div class="card-body text-center d-flex flex-column justify-content-center">
              <h3 class="card-title" [ngClass]="widget.colorClass">
                {{ translationService.getTranslation(widget.title) }}
              </h3>
              <h1><i [class]="widget.icon"></i></h1>
            </div>
          </div>
        </div>
        </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="card shadow-sm border-0" style="height: 420px;">
              <div class="card-body">
                <h3 class="card-title">{{ translationService.getTranslation('Candidate Distribution') }}</h3>
                <canvas id="candidateDistributionChart"></canvas>
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover">
        <thead class="table-success text-center">
          <tr>
            <th scope="col">{{ translationService.getTranslation('#') }}</th>
            <th scope="col">{{ translationService.getTranslation('Report Name') }}</th>
            <th scope="col">{{ translationService.getTranslation('Action') }}</th>              
          </tr>
        </thead>
        <tbody class="text-center">
          <tr>
            <td>1</td>
            <td>Report</td>
            <td><i class="bi bi-eye text-success me-2" style="cursor: pointer;"></i></td>
          </tr>
          <tr>
            <td>2</td>
            <td>Report</td>
            <td><i class="bi bi-eye text-success me-2" style="cursor: pointer;"></i></td>
          </tr>
          <tr>
            <td>3</td>
            <td>Report</td>
            <td><i class="bi bi-eye text-success me-2" style="cursor: pointer;"></i></td>
          </tr>
          <tr>
            <td>4</td>
            <td>Report</td>
            <td><i class="bi bi-eye text-success me-2" style="cursor: pointer;"></i></td>
          </tr>
          <tr>
            <td>5</td>
            <td>Report</td>
            <td><i class="bi bi-eye text-success me-2" style="cursor: pointer;"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        {{ translationService.getTranslation('Showing') }} 
        5
        {{ translationService.getTranslation('of') }} 
        15
        {{ translationService.getTranslation('Report') }}
      </div>
      <nav>
        <ul class="pagination m-0">
          <li class="page-item" >
            <button class="page-link text-success bg-white border-success mx-2" >
              {{ translationService.getTranslation('Previous') }}
            </button>
          </li>
    
          <li class="page-item" >
            <button class="page-link text-success bg-white border-success" >
              {{ translationService.getTranslation('Next') }}
            </button>
          </li>
        </ul>
      </nav>
    </div>

  <div class="modal fade" id="widgetModal" tabindex="-1" aria-labelledby="widgetModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 90%;">
      <div class="modal-content border-0 shadow">
        <div class="modal-header">
          <h5 class="modal-title mx-3" id="widgetModalLabel" >
            {{ selectedWidget?.title ? translationService.getTranslation(selectedWidget.title) : '' }}
          </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

          <div class="d-flex flex-column gap-2 py-2">
            <div class="d-flex gap-3 flex-wrap">
              <div style="min-width: 220px;" *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('ID Number') }}:</label>
                <input type="text" class="form-control" [(ngModel)]="IDNumber" placeholder="{{ translationService.getTranslation('ID Number') }}" />
              </div>

              <div style="min-width: 220px;" *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('Select Course') }}:</label>
                <select class="form-control" [(ngModel)]="selectedCourseFilter">
                  <option value="">{{ translationService.getTranslation('All Courses') }}</option>
                  <option *ngFor="let course of uniqueCourses" [value]="course">
                    {{ course }}
                  </option>
                </select>
              </div>

              <div style="min-width: 200px;" *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('Select Language') }}:</label>
                <select class="form-control" [(ngModel)]="selectedLangFilter">
                  <option value="">{{ translationService.getTranslation('All Languages') }}</option>
                  <option *ngFor="let lang of uniqueLanguages" [value]="lang">
                    {{ lang }}
                  </option>
                </select>
              </div>

              <div style="min-width: 200px;" *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('Book Type') }}:</label>
                <select class="form-control" [(ngModel)]="selectedBookingTypeFilter">
                  <option value="">{{ translationService.getTranslation('All Book Type') }}</option>
                  <option *ngFor="let type of uniqueBookingTypes" [value]="type">
                    {{ type }}
                </select>
              </div>

              <div style="min-width: 200px;" *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('Gender') }}:</label>
                <select class="form-control" [(ngModel)]="selectedGenderFilter">
                  <option value="">{{ translationService.getTranslation('All Genders') }}</option>
                  <option *ngFor="let gender of uniqueGenders" [value]="gender">
                    {{ gender }}
                  </option>
                </select>
              </div>
              
              <div *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('From Date') }}:</label>
                <input type="date" class="form-control" [(ngModel)]="fromDate" [min]="minDate">
              </div>

              <div *ngIf="selectedWidget?.title == 'Candidate Results' || selectedWidget?.title == 'Exam Violations'">
                <label class="form-label mb-1">{{ translationService.getTranslation('To Date') }}:</label>
                <input type="date" class="form-control" [(ngModel)]="toDate" [min]="minDate">
              </div>

              <div style="min-width: 220px;" *ngIf="selectedWidget?.title == 'Test Details'">
                <label class="form-label mb-1">{{ translationService.getTranslation('Exam Attendance Number') }}:</label>
                <input type="text" class="form-control" [(ngModel)]="examAttendNumber" placeholder="{{ translationService.getTranslation('Exam Attendance Number') }}" />
              </div>

              <div style="min-width: 220px;" class="mt-1" *ngIf="selectedWidget?.title == 'Test Details'">
                <br>
                <button [disabled]="!examAttendNumber" class="btn btn-success w-100" (click)="searchTestDetails()">
                  {{ translationService.getTranslation('Search') }}
                </button>
              </div>

              <div class="d-flex align-items-end" style="min-width: 150px;">
                <button [disabled]="selectWidget.length < 1 || selectedWidget?.title == 'Performance'" class="btn btn-success w-100 mt-auto" (click)="exportToExcel()">
                  {{ translationService.getTranslation('Export') }}
                </button>
              </div>
            </div>
          </div>
          
          <div *ngIf="selectedWidget?.title == 'Candidate Results'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Fully Correct') }}</th>
                  <th>{{ translationService.getTranslation('Fully Wrong') }}</th>
                  <th>{{ translationService.getTranslation('Partially Correct') }}</th>
                  <th>{{ translationService.getTranslation('Questions Postponed') }}</th>
                  <th>{{ translationService.getTranslation('Questions Skipped') }}</th>
                  <th>{{ translationService.getTranslation('Exam Date') }}</th>
                  <th>{{ translationService.getTranslation('Marks') }}</th>
                  <th>{{ translationService.getTranslation('Result') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredCandidateResults">
                  <td>{{ student.IDNumber }}</td>
                  <td>{{ student.TraineeName }}</td>
                  <td>{{ student.ExamAttendanceNo }}</td>
                  <td>{{ student.PhoneNumber }}</td>
                  <td>{{ student.CourseName }}</td>
                  <td>{{ student.courseLang }}</td>
                  <td>{{ student.BookingType }}</td>
                  <td>{{ student.Gender }}</td>
                  <td>{{ student.FullyCorrectCount }}</td>
                  <td>{{ student.FullyWrongCount }}</td>
                  <td>{{ student.PartialCorrectCount }}</td>
                  <td>{{ student.Postponed }}</td>
                  <td>{{ student.Skipped }}</td>
                  <td>{{ student.EndExamTime | date:'MM/dd/yyyy' }}</td>
                  <td>{{ student.Marks }}</td>
                  <td>{{ student.ExamResult }}</td>
                </tr>                               
              </tbody>
            </table>
            <div class="pt-2">
              <p>{{ translationService.getTranslation('Total Candidates') }}: {{this.filteredCandidateResults.length}}</p>
            </div>
          </div>  
                      
          <div *ngIf="selectedWidget?.title == 'Test Details'" class="table-responsive">

            <table class="table table-sm table-bordered table-striped table-hover" *ngIf="TraineeName">
              <tbody>
                <tr>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <td>{{ TraineeName }}</td>
                  <th>{{ translationService.getTranslation('ID Number') }}</th>
                  <td>{{ IDNumber }}</td>
                </tr>
                <tr>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <td>{{ selectedGenderFilter }}</td>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <td>{{ LanguageName }}</td>
                </tr>
                <tr>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <td>{{ CourseName }}</td>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <td>{{ selectedBookingTypeFilter }}</td>
                </tr>
                <tr>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <td>{{ examAttendNumber }}</td>
                  <th>{{ translationService.getTranslation('Marks') }}</th>
                  <td>{{ Marks }}</td>
                </tr>
                <tr>
                  <th>{{ translationService.getTranslation('Result') }}</th>
                  <td colspan="3">{{ ExamResult }}</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('Form Number') }}</th>
                  <th>{{ translationService.getTranslation('Unit Name') }}</th>
                  <th>{{ translationService.getTranslation('Question ID') }}</th>
                  <th>{{ translationService.getTranslation('Question') }}</th>
                  <th>{{ translationService.getTranslation('Question Type') }}</th>
                  <th>{{ translationService.getTranslation('Question Level') }}</th>
                  <th>{{ translationService.getTranslation('IsAnswered') }}</th>
                  <th>{{ translationService.getTranslation('IsCorrect') }}</th>
                  <th>{{ translationService.getTranslation('IsSkipped') }}</th>
                  <th>{{ translationService.getTranslation('IsPostponed') }}</th>
                  <th>{{ translationService.getTranslation('ResponseTimeInSecondes') }}</th>
                  <th>{{ translationService.getTranslation('Score') }}</th>
                  <th>{{ translationService.getTranslation('Answered Text') }}</th>
                  <th>{{ translationService.getTranslation('CorrectAnswer') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of testDetailsWidget">
                  <td>{{ item.FormNumber || "--" }}</td>
                  <td>{{ item.UnitName || "--" }}</td>
                  <td>{{ item.QuestionID || "--" }}</td>
                  <td>{{ item.QuestionText || "--" }}</td>
                  <td>{{ item.QuestionType || "--" }}</td>
                  <td>{{ item.QuestionLevel || "--" }}</td>
                  <td>{{ item.IsAnswered ? '✔️' : '❌' }}</td>
                  <td>{{ item.IsCorrect ? '✔️' : '❌' }}</td>
                  <td>{{ item.IsSkipped ? '✔️' : '❌' }}</td>
                  <td>{{ item.IsPostponed ? '✔️' : '❌' }}</td>
                  <td>{{ item.ResponseTimeInSecondes || "--" }}</td>
                  <td>{{ item.Score || "--" }}</td>
                  <td>{{ item.SelectedAnswers || "--" }}</td>
                  <td>{{ item.CorrectAnswers || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="selectedWidget?.title == 'Exam Violations'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Start Exam') }}</th>
                  <th>{{ translationService.getTranslation('Flag') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let candidate of filteredexamViolationsWidget">
                  <td>{{ candidate.IDNumber }}</td>
                  <td>{{ candidate.ExamAttendanceNo }}</td>
                  <td>{{ candidate.TraineeName }}</td>
                  <td>{{ candidate.PhoneNumber }}</td>
                  <td>{{ candidate.Gender }}</td>
                  <td>{{ candidate.BookingType }}</td>
                  <td>{{ candidate.CourseName }}</td>
                  <td>{{ candidate.LanguageName }}</td>
                  <td>{{ candidate.StartExamDate | date:'HH:mm' }}</td>
                  <td>
                    <i class="bi bi-eye text-primary me-2" (click)="viewReport(candidate)" style="cursor: pointer;"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="pt-2">
              <p>{{ translationService.getTranslation('Total Candidates') }}: {{this.candidateResultsWidget.length}}</p>
            </div>
          </div>

          <div *ngIf="selectedWidget?.title == 'Performance'" class="table-responsive">
            <!-- soon -->
            <h2 class="text-center">{{ translationService.getTranslation('Performance report is under development') }}</h2>
            <!-- <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Exam Date') }}</th>
                  <th>{{ translationService.getTranslation('Session Time') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredUpcomingExamCandidates">
                  <td>{{ student.id }}</td>
                  <td>{{ student.name }}</td>
                  <td>{{ student.phone }}</td>
                  <td>{{ student.courseName }}</td>
                  <td>{{ student.language }}</td>
                  <td>{{ student.bookType }}</td>
                  <td>{{ student.gender }}</td>
                  <td>{{ student.examDate | date:'MM/dd/yyyy' }}</td>
                  <td>{{ student.sessionTime }}</td>
                </tr>                               
              </tbody>
            </table>
            <div class="pt-2">
              <p>{{ translationService.getTranslation('Total Candidates') }}: {{this.performanceWidget.length}}</p>
            </div> -->
          </div>      
        </div>
      </div>
    </div>
  </div>

  </div>